import {useEffect, useState, useRef} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import Header from '../layout/header/Header'
import Login from '../auth/login/Login'
import { checkEmergency } from "../../redux/actions/dataActions";
import {setAsAuthenticated, getMeDetails} from '../../redux/actions/authActions'
import './Content.css'
import Footer from '../layout/footer/Footer'
import { getHomeData } from '../../redux/actions/dataActions'
import { Routes, Route, Navigate, useNavigate, useLocation } from "react-router-dom";
import Form from "../form/Form"
import Appointments from '../appointments/Appointments'
import Appointment from '../appointments/Appointment'
import Snackbar from '@mui/material/Snackbar';
import { close } from '../../redux/actions/modalActions'
import AccessibilityStatement from '../accessibility/AccessibilityStatement'
import { APP_VERSION } from '../../config/version'
import AppFooterMobile from '../layout/footer/AppFooterMobile'
import AddToCalendarPage from '../common/AddToCalendarPage'
import { useI18n, setEnabledLangs } from '../../i18n'
import LanguageSwitcher from '../../i18n/LanguageSwitcher'
import { fetchSiteConfig } from '../../redux/actions/dataActions'

// Mobile login-screen footer: the accessibility link + a compact copyright, pinned above
// the login CTA. ★ התוכן עבר ל-`AppFooterMobile` כדי שאותו פוטר יופיע גם בתחתית
// "התורים שלי" אחרי ההתחברות (בקשת-משתמש 27/07) בלי לשכפל את הנוסח והגרסה.
// שם-הקלאס `ans-mobile-footer` נשמר — כל מיקום-הלוגין ב-Login.css תלוי בו.
const MobileFooter = () => <AppFooterMobile className="ans-mobile-footer" />



function Content() {
  
  const { isAuthenticated, user } = useSelector((state) => state.auth);
   const {
    loadingEmergency,
    emergencyMode,
    emergencyText,      // remember to store this in your reducer
    emergencyError
  } = useSelector((s) => s.data);
  const { modal_name } = useSelector((state) => state.modal);

  const dispatch = useDispatch()
  const location = useLocation()
  const { t, lang } = useI18n()

  /* ★★ F1 — החלפת-שפה חייבת **לטעון מחדש את הנתונים מהשרת**.
     ⚠️ הבאג שזה סוגר (דיווח-משתמש 27/07: "חוזר מאנגלית לעברית והוא לא
        מתרגם"): ‏`user/me` נטען פעם אחת בעליית האפליקציה, ושמות המחלקות
        והיומנים מגיעים ממנו **כשהם כבר מתורגמים בשרת** לפי ה-`lang` של אותה
        בקשה. החלפת-שפה בדפדפן החליפה רק את מחרוזות-הממשק, ולכן שמות
        המחלקות נשארו תקועים בשפה שבה נטענו — לכל כיוון, לא רק חזרה לעברית.
     ★ מדלגים על הריצה הראשונה: שם הנתונים כבר נטענים ע"י זרימת-האתחול,
       וקריאה נוספת הייתה כפילות בכל טעינת-דף. */
  const langBootRef = useRef(true)
  useEffect(() => {
    if (langBootRef.current) { langBootRef.current = false; return }
    /* ⚠️⚠️ **מותנה ב-`isAuthenticated` ולא בקיום טוקן ב-localStorage.**
       הבאג שזה סוגר (דיווח-משתמש 27/07: "הסשן מתנתק בכל רענון וצריך קוד
       שוב"): הטוקן יושב ב-localStorage כבר בפריים הראשון, אבל הכותרת
       ‏`Authorization` מוזרקת ל-axios רק בתוך ה-`.then()` של `checkEmergency`
       ← `setAsAuthenticated`. קריאה ל-`user/me` בחלון שביניהם יוצאת **בלי
       טוקן**, חוזרת 401, ו-`getMeDetails` מגיב על 401 ב-`LOGOUT` — כלומר
       פיצ'ר-תרגום היה מנתק את האזרח.
       ★ ‏`isAuthenticated` הופך לאמת בדיוק אחרי `setAsAuthenticated`, ולכן
         הוא הסימן הנכון לכך שה-axios מוכן. */
    if (isAuthenticated) { dispatch(getMeDetails()) }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lang])

  /* ★★ F1 — בורר-השפה מוצג **רק בשני מסכי-הפתיחה**: מסך-הלוגין ו"התורים שלי"
     (בקשת-משתמש 27/07). הנימוק: האזרח בוחר שפה פעם אחת בכניסה, ומשם והלאה
     המסכים הפנימיים (טופס-ההזמנה, פרטי-התור, עריכה) צפופים ממילא — בורר קבוע
     בהם היה גוזל מקום בלי להוסיף ערך.
     ⚠️ ‏`pathname` מנוקה מסלאשים בסוף כדי ש-`/` ו-`//` יזוהו שניהם כדף-הבית. */
  const isHomeRoute = location.pathname.replace(/\/+$/, '') === ''
  const showLangSwitcher = !isAuthenticated || isHomeRoute

  /* ★★ F1 — אילו שפות הלקוח הדליק בהגדרות-האתר. נטען פעם אחת בעליית האפליקציה
     ומוזרם למנוע-התרגום, שמסנן לפיו את הבורר.
     ★ נטען כאן ולא ב-`LanguageSwitcher` כי הבורר מוצג רק בשני מסכים — והרשימה
       נדרשת גם כדי **לבטל** שפה שנשמרה ב-localStorage ואינה פעילה עוד.
     ⚠️ כישלון-רשת מחזיר {} ⇒ רשימה ריקה ⇒ בלי בורר. זו ההתנהגות הבטוחה:
        עדיף בלי בורר מאשר בורר שמציע שפה שהשרת לא יתרגם. */
  useEffect(() => {
    let alive = true
    fetchSiteConfig()(dispatch).then((cfg) => {
      if (alive) setEnabledLangs(Array.isArray(cfg?.languages) ? cfg.languages : [])
    })
    return () => { alive = false }
  }, [dispatch])

  /* ★★ הבהוב אחרי רענון (דיווח-משתמש 27/07): הטוקן יושב ב-localStorage, אבל redux
     מסומן "מאומת" רק ב-`.then` של `checkEmergency` — ובפריים שבין סיום-הבדיקה
     לבין ה-dispatch נרונדר **מסך-הלוגין עם הפוטר שלו**, ולכן נראו לרגע שורת-
     הזכויות והצהרת-הנגישות הישנות ורק אחר-כך מסך-התורים. כאן ממתינים לסיום
     האתחול לפני שמציגים לוגין, כך שאין מצב-ביניים גלוי.
     ★ רשת-ביטחון: אם האימות לא מסתיים (אופליין / שרת לא-זמין) — אחרי 4 שניות
       מפסיקים לחכות ומציגים לוגין. ספינר נצחי גרוע ממסך-כניסה.
     ★ טוקן פגום/פג אינו תוקע: ‏`LOGOUT` מוחק את הטוקן מ-localStorage, ולכן
       ברענון הבא אין בכלל המתנה. */
  const [authSettled, setAuthSettled] = useState(!localStorage.getItem('token'))
  useEffect(() => {
    if (authSettled) return
    if (isAuthenticated) { setAuthSettled(true); return }
    const t = setTimeout(() => setAuthSettled(true), 4000)
    return () => clearTimeout(t)
  }, [authSettled, isAuthenticated])

  /* ★ שער-הטעינה הראשוני **ממתין גם לנתוני-התורים** (‏user/me), לא רק להסדרת-
     הסשן — כדי שלא יהיו שני שלבי-טעינה (splash ואז ספינר-נתונים נפרד). הלואדר
     נשאר עד שהכל מוכן, ואז התוכן מוצג בבת-אחת (דיווח-משתמש 11/08).
     ★ הלואדר זהה ל-splash שב-public/index.html (אותו אייקון-ANS מסתובב על אותו
       רקע) ⇒ המעבר splash→React חלק, בלי הבזק ובלי החלפת-מחוון.
     ⚠️ רשת-ביטחון: אם הנתונים לא מגיעים (שרת נופל) — אחרי 8 שניות מפסיקים לחכות
       ומציגים את האפליקציה, כדי שלא ניתקע בספינר-נצחי. `user/me` שנכשל ב-401
       ממילא עושה LOGOUT ⇒ מסך-לוגין. */
  const homeDataLoaded = Array.isArray(user?.visitors)
  const [dataTimedOut, setDataTimedOut] = useState(false)
  useEffect(() => {
    if (!isAuthenticated || homeDataLoaded) { setDataTimedOut(false); return }
    const timer = setTimeout(() => setDataTimedOut(true), 3500)
    return () => clearTimeout(timer)
  }, [isAuthenticated, homeDataLoaded])

  /* ★★★ escape-hatch קשיח: לא משנה מה קורה (בקנד לא-נגיש מהטלפון, `user/me`
     שנתקע, וכו') — אחרי 6 שניות מרגע-העלייה **תמיד** פותחים את השער ומציגים
     את האפליקציה, כדי שהמשתמש לעולם לא ייתקע על מסך-הטעינה (דיווח-משתמש 11/08:
     "ממשיך לטעון ולא מגיע למסך התורים"). */
  const [bootGaveUp, setBootGaveUp] = useState(false)
  useEffect(() => {
    const t = setTimeout(() => setBootGaveUp(true), 6000)
    return () => clearTimeout(t)
  }, [])

  const gateActive = !bootGaveUp && (
       loadingEmergency
    || (!authSettled && !isAuthenticated)
    || (isAuthenticated && !homeDataLoaded && !dataTimedOut)
  )

  /* ★ ה-splash הסטטי (‏#app-loader ב-public/index.html) הוא הלואדר **היחיד**:
     נשאר גלוי מרגע-הטעינה ועד שהשער נפתח (הכל מוכן), ואז מוסתר. אם השער נסגר
     שוב — מוחזר. כך אין שני ספינרים נפרדים שההנפשה שלהם קופצת בהחלפה. */
  useEffect(() => {
    const el = document.getElementById('app-loader')
    if (el) { el.style.display = gateActive ? 'flex' : 'none' }
  }, [gateActive])


useEffect(() => {
    dispatch(checkEmergency()).then(() => {
      // once emergency check finishes, if no emergency and token exists:
      if (!emergencyMode && localStorage.getItem("token")) {
        const token = localStorage.getItem("token");
        dispatch(setAsAuthenticated(token));
        dispatch(getHomeData());
      }
    });
  }, [dispatch, emergencyMode]);
  
  

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    dispatch(close())
  }

  // public "add to calendar" landing page (reached from the booking-confirmation SMS link).
  // Rendered before any auth/emergency/loading gate so the SMS recipient — usually not logged
  // in — can add the appointment to Google/Outlook without signing in.
  if (location.pathname.replace(/\/+$/, '').endsWith('/add-to-calendar')) {
    return <AddToCalendarPage />;
  }

// ★ גם בזמן האתחול-מחדש (טוקן קיים, redux עוד לא מאומת) מציגים את מסך-הטעינה
//   ולא את הלוגין — ראה ההסבר ב-`authSettled` למעלה.
if (gateActive) {
    // ה-splash הסטטי (#app-loader) עדיין מכסה את המסך — הוא הלואדר היחיד עד
    // שהכל מוכן. לא מרנדרים כאן לואדר משלנו כדי שלא יהיו שני ספינרים נפרדים.
    return null;
  }

 
  if (emergencyMode) {
  return (
       <div className='content_page'>
      <div className='content'>
      <h1 className="sr-only">{t('content.srTitle')}</h1>
      <Header />
      {showLangSwitcher && (
        <div className="ans-lang-slot"><LanguageSwitcher /></div>
      )}
    <Login emergencyText={emergencyText} />
        {!isAuthenticated && <MobileFooter />}
          </div>
    </div>
  );
}
  return (
    <div className='content_page'>
      <div className='content'>
        {/* a11y (WCAG best-practice): one page-level h1 for document structure (visually hidden) */}
        <h1 className="sr-only">{t('content.srTitle')}</h1>
        <Header />
        {/* F1 — צד ימין של המסך, מעל התוכן. ראה ההסבר ב-`showLangSwitcher`. */}
        {showLangSwitcher && (
          <div className="ans-lang-slot"><LanguageSwitcher /></div>
        )}
        {!isAuthenticated ? <Login />
        : <Routes>
            <Route key={"form"} path={"/form"} element={<Form />} />
            <Route key={"home"} path={'/'} element={<Appointments />} />
            <Route key={"appointment"} path={"appointment/:id"} element={<Appointment/>}  />
            {/* ★★★ נתיב לא-מוכר ⇒ חזרה לרשימת-התורים (דיווח-משתמש 16/08/2026).
                ⚠️ הבאג: לא היה כאן catch-all, ולכן כתובת כמו `/1` לא התאימה
                   לאף Route ו-`<Routes>` רינדר **כלום**. האזרח קיבל מסך לבן
                   עם הלוגו וכפתור-ההתנתקות בלבד — נראה כאפליקציה שנשברה, בלי
                   שום דרך לחזור. (קישור-SMS ישן, הקלדה, או היסטוריית-דפדפן.)
                ★ `replace` ולא ניווט רגיל: אחרת "אחורה" בדפדפן היה מחזיר
                  לאותה כתובת שבורה ויוצר לולאה.
                ⚠️ חל רק על משתמש **מחובר** — אורח מקבל `<Login />` בכל נתיב,
                   כלומר הענף הזה כבר מטופל למעלה.
                ★★ מקביל בבקנד: `SiteController::actionError` מפנה אורח על
                   נתיב-בקנד שגוי לאתר-הזימון (ראה `ansFrontendUrl()`). שני
                   הצדדים צריכים לענות "לאן חוזרים", אחרת אחד מהם משאיר
                   את המשתמש תקוע. */}
            <Route key={"fallback"} path={"*"} element={<Navigate to={"/"} replace />} />
             </Routes>}
             <Snackbar
                open={modal_name == 'snack_bar'}
                autoHideDuration={2000}
                onClose={handleClose}
                message={t('content.actionDone')}
                anchorOrigin={{vertical: 'top', horizontal: 'right'}}
              />

        {!isAuthenticated && <MobileFooter />}
      </div>
    </div>
  )
}

export default Content
